module.exports = __webpack_public_path__ + "img/tema-1-3.53d7dd00.svg";